module.exports = __webpack_public_path__ + "img/tiklanish-3.4e8f18e9.png";